import type { MetaFunction } from '@remix-run/node';
import type { ListItem } from 'schema-dts';
import type { loader as productsLoader } from '~/routes/_app.products.$';
import { constructProductSchema } from './product-schema';
import { getMetaBaseUrl } from '../util/create-meta-base-url';
import type { StaticParentLoaders } from '../util';

export const createProductsItemListSchema: MetaFunction<
    typeof productsLoader,
    StaticParentLoaders
> = (props) => {
    if (!props.data) {
        return [];
    }
    const { data, location } = props;
    const baseUrl = getMetaBaseUrl(props);
    const itemListElement: ListItem[] = props?.data.productTiles?.map(
        (product, idx) => {
            return {
                '@type': 'ListItem',
                position: data.pagination?.currentRange?.from + idx,
                item: {
                    ...constructProductSchema({
                        id: product.productId,
                        title: product.tile.productName,
                        description: product.tile.seoDescription,
                        url: baseUrl + product.link,
                        image: product.tile.image?.[0]?.src ?? '',
                        professionalName: product.tile.professionalName,
                        price: {
                            price: product.tile.price
                                ? product.tile.price
                                      ?.replace('$', '')
                                      ?.replace(',', '')
                                : '0.00',
                        },
                        variantCount: product.tile.variants.length || 1,
                        priceCurrency: product.tile.priceCurrency ?? 'NZD', // add to ES pricing
                    }),
                },
            };
        }
    );
    return [
        {
            '@type': 'ItemList',
            url: baseUrl + location.pathname,
            numberOfItems: data.searchResult?.nbHits,
            itemListElement,
        },
    ];
};
